export function createAbortMiddleware() {
  let controller = new AbortController();

  const middleware =
    next =>
    async (url, init = {}) => {
      try {
        return await next(url, { ...init, signal: controller.signal });
      } catch (err) {
        if (err instanceof DOMException && err.name === 'AbortError') {
          throw new DOMException('AbortError', 'AbortError');
        }
        throw err;
      }
    };

  const abort = () => {
    controller.abort();
    controller = new AbortController(); // Nový controller pro další requesty
  };

  const getController = () => controller;

  return { middleware, abort, getController };
}
